import { render, staticRenderFns } from "./SysDataSourceModal.vue?vue&type=template&id=2b94608b&scoped=true&"
import script from "./SysDataSourceModal.vue?vue&type=script&lang=js&"
export * from "./SysDataSourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b94608b",
  null
  
)

export default component.exports